<template>
  <div id="app" style="height:100%;">
    <el-container style="height:100%;">
      <!-- Header 现在是固定定位，不需要 el-header 容器 -->
      <topNav></topNav>
      <el-main class="main">
        <router-view></router-view>
      </el-main>
      <el-footer class="footer"  style="height:300px;">
        <footer-dom></footer-dom>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import topNav from "../components/TopNav.vue";
import footerDom from "../components/footer.vue";
export default {
  components: {
    topNav,
    footerDom
  },
  data() {
    return {};
  }
};
</script>  
<style>
* {
  padding: 0;
  margin: 0;
}
.el-main,.el-footer{
  padding: 0 !important;
}
.main{
  width: 100%;
  margin: 0 auto;
  padding: 0;
}
.footer{
  width: 100%;
  padding: 0;
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

</style>


// WEBPACK FOOTER //
// src/layout/index.vue